/** @jsxRuntime classic */
/** @jsx jsx */
/*
License

Copyright (c) 2022 Chukwubuikem Ume-Ugwa

Permission is hereby witheld, any person obtaining a copy
of this software and associated documentation files (the "Software"), cannot
use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software. These restrictions can be only lifted with
a written permission from Chukwubuikem Ume-Ugwa.
*/
import {
  Text,
  Button,
  Container,
  Flex,
  Image,
  Badge,
  Box,
} from '@chakra-ui/react';
import { useCallback, useState, useEffect } from 'react';
import { firebaseFacade } from '../api/firebase';
import { log } from '../utils';
import { css, jsx } from '@emotion/react';
import { isBrowser } from 'react-device-detect';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { NavigationEvent, UiStates } from './stream.component';
import { GEOFENCED, PRIVATE } from '../api/schemas';

export function NewQueueComponent(props) {
  const { queue, streamingqAddress, onStream, isPlaying, onPushView } = props;

  const { name, art_uri } = queue;
  const [showPlayButton, setShowPlayButton] = useState(false);
  const [tracks, setTracks] = useState([]);

  const [innerIsPlaying, setIsPlaying] = useState(false);

  const handlePlay = useCallback(() => {
    log({
      component: 'NewQueueComponent',
      msg: 'play button clicked',
      previousQueueAddress: streamingqAddress,
      queue: queue,
      tracks: tracks,
    });

    firebaseFacade.updateMonthlyStreams(queue);
    onStream(
      queue.queue_address,
      queue,
      !innerIsPlaying,
      queue.queue_address === streamingqAddress,
      tracks
    );
  }, [queue, innerIsPlaying, tracks, streamingqAddress]);

  const handleOpenQueuePage = useCallback(() => {
    onPushView(
      new NavigationEvent(UiStates.six, {
        previousQueueAddress: streamingqAddress,
        queue: queue,
        tracks: tracks,
      })
    );
  }, [streamingqAddress, tracks]);

  const onTrackLoaded = useCallback(async tracks => {
    log({
      component: 'NewQueueComponent',
      msg: 'onTrackLoaded called',
      tracks: tracks,
    });
    for (let idx = 0; idx < tracks.length; idx++) {
      await firebaseFacade.loadAudio(tracks[idx]);
    }
    setTracks(tracks);
  }, []);

  const renderBadge = useCallback(() => {
    const { type } = queue;
    if (type === GEOFENCED)
      return (
        <Box>
          <Badge colorScheme="purple">Geofenced</Badge>
        </Box>
      );

    if (type === PRIVATE)
      return (
        <Box>
          <Badge colorScheme="purple">Private</Badge>
        </Box>
      );
  }, []);

  useEffect(
    () => firebaseFacade.listenForTrackChanges(onTrackLoaded, queue),
    [queue]
  );
  
  useEffect(() => {
    setIsPlaying(isPlaying && queue.queue_address === streamingqAddress);
  }, [isPlaying, streamingqAddress]);

  return (
    <Container
      marginLeft={['8px']}
      onMouseEnter={() => setShowPlayButton(true)}
      onMouseLeave={() => setShowPlayButton(false)}
      height={['200px', '260px', '270px', '360px', '370px']}
      width={['190px', '250px', '250px', '350px', '300px']}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-content: space-between;
        `}
      >
        <Image
          borderRadius={'2xl'}
          src={`${
            art_uri || process.env.PUBLIC_URL + '/android-chrome-512x512.png'
          }`}
          onClick={handleOpenQueuePage}
          height={['190px', '150px', '150px', '250px', '250px']}
          width={['190px', '150px', '150px', '250px', '250px']}
        />
        {renderBadge()}
        <Text className="text-white" fontSize={['md', 'xl']} noOfLines={1}>
          {name}
        </Text>
      </div>
      <Flex position={'relative'} top={['5px']}>
        {showPlayButton && isBrowser && (
          <Button
            position={'absolute'}
            top={'-150px'}
            right={'10px'}
            onClick={handlePlay}
            bg={'yellow.400'}
            color={'black'}
            width={'40px'}
            height={'40px'}
            borderRadius={'50%'}
          >
            {innerIsPlaying ? <PauseIcon /> : <PlayArrowIcon />}
          </Button>
        )}
      </Flex>
    </Container>
  );
}
